import { LLMStreamRequest, LLMStreamEvent, LLMStreamEventType } from '@packages/global';
import { useAuthStore } from '../../stores/authStore';

// 生产环境使用相对路径，开发环境使用配置的地址
const API_BASE_URL = import.meta.env.PROD
  ? '/api'
  : (import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000/api');

export const llmApi = {
  /**
   * SSE 流式生成
   * @param request 请求参数
   * @param onEvent 事件回调
   * @param signal AbortSignal 用于取消请求
   */
  async stream(
    request: LLMStreamRequest,
    onEvent: (event: LLMStreamEvent) => void,
    signal?: AbortSignal
  ): Promise<void> {
    const token = useAuthStore.getState().token;

    const response = await fetch(`${API_BASE_URL}/user/llm/stream`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify(request),
      signal,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const reader = response.body?.getReader();
    if (!reader) {
      throw new Error('No response body');
    }

    const decoder = new TextDecoder();
    let buffer = '';

    try {
      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        buffer += decoder.decode(value, { stream: true });
        const lines = buffer.split('\n');
        buffer = lines.pop() || '';

        for (const line of lines) {
          if (line.startsWith('data: ')) {
            try {
              const data = JSON.parse(line.slice(6));
              onEvent(data as LLMStreamEvent);
            } catch (e) {
              console.error('Failed to parse SSE data:', e);
            }
          }
        }
      }
    } finally {
      reader.releaseLock();
    }
  },
};
